import {
  Box,
  Flex,
  Text,
  Heading,
  Button,
  Stack,
  Link as ChakraLink,
  SimpleGrid,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';

const compareLinks = [
  { to: '/compare/classy', label: 'PurelyGive vs Classy' },
  { to: '/compare/donorbox', label: 'PurelyGive vs Donorbox' },
  { to: '/compare/givebutter', label: 'PurelyGive vs Givebutter' },
  { to: '/compare/stripe', label: 'PurelyGive vs Stripe' },
];

export default function SiteFooter() {
  return (
    <>
      <Box w="100%" py={16} px={6} bg="#0f393b" color="white" textAlign="center">
        <Heading as="h2" size="xl" mb={4}>
          Stay Dedicated to Your Cause. Leave the Fees Behind.
        </Heading>
        <Text fontSize="lg" mb={8}>
          Every Dollar Drives Change.
        </Text>
        <Button
          size="lg"
          as={Link}
          to="/register"
          colorScheme="orange"
          px={8}
          py={6}
          _hover={{ bg: 'orange.600' }}
        >
          Join Now for Free!
        </Button>
      </Box>
      <Box as="footer" bg="gray.800" color="gray.200" py={10}>
        <Flex maxW="1200px" mx="auto" px={6} direction="column" gap={6}>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
            <Stack spacing={2}>
              <Text fontWeight="bold">Company</Text>
              <ChakraLink as={Link} to="/" color="gray.200">Home</ChakraLink>
              <ChakraLink as={Link} to="/privacy-policy" color="gray.200">Privacy Policy</ChakraLink>
              <ChakraLink as={Link} to="/terms-and-conditions" color="gray.200">Terms and Conditions</ChakraLink>
              <ChakraLink as={Link} to="/contact" color="gray.200">Contact Us</ChakraLink>
            </Stack>

            <Stack spacing={2}>
              <Text fontWeight="bold">Compare Platforms</Text>
              <ChakraLink as={Link} to="/compare" color="gray.200">Comparison Hub</ChakraLink>
              {compareLinks.map((item) => (
                <ChakraLink key={item.to} as={Link} to={item.to} color="gray.200">
                  {item.label}
                </ChakraLink>
              ))}
            </Stack>
          </SimpleGrid>
          <Text>© 2026 PurelyGive. All rights reserved.</Text>
        </Flex>
      </Box>
    </>
  );
}
